import { EMAIL_QUERY_PARAM_NAME } from 'domains/userSettings/const';

export const getSearchEmailParam = (search = '') => {
  return new URLSearchParams(search).get(EMAIL_QUERY_PARAM_NAME);
};
